import { createGrid, themeQuartz } from 'ag-grid-community'
// import { addListeners } from '../listeners.js'
import { makeColumnDefs } from './make-column-defs.js'
import { setElementHtml } from '../../../../../helpers/generic-js/dom.js'
import { ascending } from 'd3'

export function showTableAssociatedEntities (params) {
  console.log('showTableAssociatedEntities')

  const { browserAppAccount } = params

  const associatedEntities = browserAppAccount.data.entities
  console.log('associatedEntities', associatedEntities)

  // const rows = makeRows(browserAppAccount, entitiesSyncStatsResponse)
  // console.log('rows', rows)

  const columnDefs = makeColumnDefs()
  console.log('columnDefs', columnDefs)

  const context = {
    accountingOrganisations: associatedEntities
  }

  associatedEntities.sort((a, b) => ascending(a.name, b.name))

  const gridOptions = {
    rowData: associatedEntities,
    columnDefs,
    defaultColDef: {
      filter: false,
      floatingFilter: false
    },
    autoSizeStrategy: {
      type: 'fitCellContents'
    },
    getRowId: (cellParams) => cellParams.data.id,
    onCellClicked: function (cellParams) {
      console.log('onCellClicked', cellParams)
    },
    context,
    theme: themeQuartz
  }

  const maxGridRowsSize = 10
  if (associatedEntities.length > maxGridRowsSize) {
    gridOptions.defaultColDef.filter = true
    gridOptions.defaultColDef.floatingFilter = true
  }

  const containerId = 'entitiesGrid'
  const gridContainerElement = setElementHtml(containerId, '')

  setGridHeight(gridContainerElement, associatedEntities.length, maxGridRowsSize)

  console.log('gridContainerElement', gridContainerElement)
  const gridApi = createGrid(gridContainerElement, gridOptions)
  console.log('grid created', gridApi)
}

function setGridHeight (gridContainerElement, numberOfRows, maxGridRowsSize = 10) {
  const gridHeaderHeight = (numberOfRows > maxGridRowsSize) ? 97 : 49 // Header 49 + Filter row 48 + Border 1
  const gridRowHeight = 42
  const gridBufferHeight = 2

  const consideredRows = Math.max(1, Math.min(maxGridRowsSize, numberOfRows))
  const height = consideredRows * gridRowHeight +
    gridHeaderHeight +
    gridBufferHeight +
    (numberOfRows > maxGridRowsSize ? 21 : 0) // Half size row to show there are more
  gridContainerElement.setAttribute('style', `height: ${height}px;`)
}
